import { render, staticRenderFns } from "./MainLayout.vue?vue&type=template&id=647569f5&lang=pug&"
import script from "./MainLayout.vue?vue&type=script&lang=ts&"
export * from "./MainLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageBreadcrumbs: require('/var/www/ct-frontend/ct-front-20261029043307/node_modules/sitis-nuxt/lib/cms/PageBreadcrumbs.vue').default,LayoutPlaceholder: require('/var/www/ct-frontend/ct-front-20261029043307/node_modules/sitis-nuxt/lib/cms/LayoutPlaceholder.vue').default})
